import { TOP_NAV_ITEMS, type TopNavKey } from "./topNavConfig";
import "./topNav.css";
import logoImage from "../assets/progress-plans-logo.png";

type Props = {
  active: TopNavKey;
};

export function TopNav({ active }: Props) {
  return (
    <nav className="topnav" aria-label="Primary">
      <div className="topnav-content">
        <a className="topnav-logo" href="/">
          <img src={logoImage} alt="ProgressPlans" className="topnav-logo-img" /> ProgressPlans
        </a>
        <ul className="topnav-menu">
          {TOP_NAV_ITEMS.map((item) => (
            <li key={item.key}>
              {item.href ? (
                <a
                  className={`topnav-item ${active === item.key ? "active" : ""}`}
                  href={item.href}
                >
                  {item.label}
                </a>
              ) : (
                <span className="topnav-item disabled" aria-disabled="true">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
